// extracted by mini-css-extract-plugin
module.exports = {"pointer":"tab__pointer--234cu","navigation":"tab__navigation--BoeFp","label":"tab__label---1ZsJ"};